/**
 * K线成交量
 * 增加MA5, MA10成交量展示
 */
import {
  LINE_TYPE,
  KLINE_MATYPE,
} from '../setting.js';
import TrendTurnoverState from '../trendturnover';
import KLineFootDectorator from '../dectorator/klinefootdectorator';
import {checkFootAuth, checkFootTitleAuth} from '../dectorator/checkauthdectorator/index.js';
import Util, {mergeModelData, numberFormat, curryFun,TradVolume} from '../../util/index.js';
import {checkHKM} from '../../controller/util.js';
const model = {
  maData: {
    Type: Object,
    Default: () => ({})
  }
};
export default class KLineTurnoverState extends KLineFootDectorator(TrendTurnoverState) {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    let {maData} = this.state.data;
    const {
      KLINE_MA5,
      KLINE_MA10
    } = KLINE_MATYPE;
    const {[KLINE_MA5]: ma5, [KLINE_MA10]: ma10} = maData;
    this.calcRange({data: [ma5, ma10], targetKey: 'business_amount', fixMinValue: 0, isAdditional: true});
  }
  _calcAxis() {
    super._calcAxis();
    const {maData} = this.state.data;
    const {
      KLINE_MA5,
      KLINE_MA10,
    } = KLINE_MATYPE;
    const {[KLINE_MA5]: ma5, [KLINE_MA10]: ma10} = maData;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'business_amount',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: ma5});
    curryCalcAxis({data: ma10});
  }
  _drawMain() {
    super._drawMain();
    const {
      left,
      width,
      right,
      bottom
    } = this.availArea;
    const {maData} = this.state.data;
    const {
      KLINE_MA5,
      KLINE_MA10,
    } = KLINE_MATYPE;
    const {[KLINE_MA5]: MA5 = [], [KLINE_MA10]: MA10 = []} = maData;
    const {LINE} = LINE_TYPE;
    const {ma5, ma10} = this.option.MA;
    const { solidColor} = this.option.FootContext;
    this._drawLine(LINE, MA5, left, bottom, ma5.lineWidth, ma5.color);
    this._drawLine(LINE, MA10, left, bottom, ma10.lineWidth, ma10.color);

    // K线辅图的左右边框
    // this._drawSolid({x:0,y:0},{x:0,y:bottom}, this.dpr, solidColor, this.context);
    // this._drawSolid({x:right,y:0},{x:right,y:bottom}, this.dpr, solidColor, this.context);
  }
  // @checkFootTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const {top} = this.availArea;
    const {business_amount, maData, current, sealObj, code, len,kline} = this.state.data;
    const {height, baseSize} = this.state;
    const {baseLine} = this.option.FootContext.title;
    const baseLineY = top + height * baseLine;
    const {ratioFixed, perHand} = sealObj;
    const {
      close_px
    } = kline[current]||0
    const {
      KLINE_MA5,
      KLINE_MA10,
    } = KLINE_MATYPE;
    const {ma5, ma10, space, arrowWidth, arrowSpace} = this.option.MA;
    const confList = {
      [KLINE_MA5]: ma5,
      [KLINE_MA10]: ma10,
    };
    const {colorMap} = this.option.BaseContext;
    let {left} = this.availArea;
    ctx2.textAlign = 'left';
    ctx2.textBaseline = 'top';
    const data = business_amount[current] || business_amount[len-1];
    let text;
    if (Util.isDef(data)) {
      const {
        sizeRatio,
        fontFamily,
        color,
      } = this.option.Turnover;
      ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      const {value} = data;
      // 成交量
      let turnover_text = TradVolume(value,code,perHand,2,close_px||0)

      text = 'Volume: ' + turnover_text;
      ctx2.beginPath();
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth + space * this.dpr;
    }
    [
      KLINE_MA5,
      KLINE_MA10,
    ].forEach(val => {
      const data = maData[val];
      if (!Util.isArray(data)) {
        return;
      }
      const item = data[current] || data[len-1];
      text = 'MAVOL' + val + ': ' + TradVolume(item.business_amount,code,perHand,1,close_px||0)
      let {
        sizeRatio,
        fontFamily,
        color,
      } = confList[val];
      ctx2.font = sizeRatio * this.state.baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      ctx2.beginPath();
      const textWidth = ctx2.measureText(text).width;
      ctx2.fillText(text, left, baseLineY);
      left += textWidth + space * this.dpr;
    })
  }
}
